import React, { useContext } from 'react'
import styled from '@emotion/styled'
import dayjs from 'dayjs'
import { useTheme } from 'emotion-theming'
import { string } from 'prop-types'

import { BellAlert } from '../svgs/BellAlert'
import { SiteConfigContext } from '../SiteConfigProvider'

const EditorialUpdatesSectionContainer = styled.div`
	align-items: flex-start;
	border: 1px solid ${({ theme }) => theme.colors.lightGrey};
	box-sizing: border-box;
	height: auto;
	justify-content: flex-end;
	margin: 0 auto;
	width: 90%;

	${({ theme }) => theme.MQ.M} {
		border: none;
		display: flex;
		height: 175px;
		flex-direction: column;
		flex-wrap: wrap;
		justify-content: flex-start;
		overflow: hidden;
		width: 100%;
	}
`
const TextSection = styled.div`
	border: none;
	display: block;
	float: left;
	height: 55px;
	overflow: hidden;
	padding: 10px;
	width: calc(100% - 80px);

	${({ theme }) => theme.MQ.M} {
		border-top: 1px solid ${({ theme }) => theme.colors.lightGrey};
		border-left: 1px solid ${({ theme }) => theme.colors.lightGrey};
		border-right: 1px solid ${({ theme }) => theme.colors.lightGrey};
		height: 45px;
		padding: 15px;
		width: calc(100% - 150px);
	}
`
const MonogramContainer = styled.div`
	display: block;
	float: right;
	margin: 0 0 0 5px;
	overflow: hidden;
	position: relative;
	right: 0;
	width: 75px;
	z-index: 0;
	-ms-overflow-style: none;

	${({ theme }) => theme.MQ.M} {
		bottom: 5px;
		margin: 0;
		order: 3;
		position: relative;
		width: 150px;
		z-index: 1;
	}
`
const UpdatedSection = styled.div`
	align-items: center;
	color: ${({ theme }) => theme.editorialUpdateSection.mainColor};
	display: flex;
	font-size: 16px;
	line-height: 24px;
	padding: 0;
	vertical-align: middle;

	${({ theme }) => theme.BMQ.MXL} {
		font-size: 15px;
		margin: 0;
		order: 1;
		padding: 0;
		line-height: 18px;
	}
`
const Date = styled.div`
	margin: 5px 0 0 5px;
`
const Text = styled.p`
	display: inherit;
	font-size: 13px;
	height: auto;
	margin: 0;
	padding: 15px;
	width: 100%;
	${({ theme }) => theme.BMQ.MXL} {
		font-size: 12px;
	}
	${({ theme }) => theme.MQ.M} {
		border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
		border-left: 1px solid ${({ theme }) => theme.colors.lightGrey};
		border-right: 1px solid ${({ theme }) => theme.colors.lightGrey};
		height: 89px;
		order: 2;
		overflow: hidden;
		padding: 5px 15px 0 15px;
		width: calc(100% - 150px);
	}
`
export const EditorialUpdatesSection = ({ lastModified, lastModifiedText }) => {
	const {
		siteComponents: { BlockMonogram },
	} = useContext(SiteConfigContext)

	const {
		colors: { lightGrey },
		editorialUpdateSection: { mainColor },
	} = useTheme()

	return (
		<EditorialUpdatesSectionContainer>
			<TextSection>
				<UpdatedSection>
					<BellAlert height="24px" width="23px" color={mainColor} />
					<Date>{`Updated ${dayjs(lastModified).format('MM/DD/YY')}`}</Date>
				</UpdatedSection>
			</TextSection>
			<MonogramContainer>
				{/* lightGrey works here because BndBlockMonogram has the color hard coded. If that were to change, we would need to update how we pass the color in */}
				<BlockMonogram color={lightGrey} height="100%" width="100%" />
			</MonogramContainer>
			<Text>{lastModifiedText}</Text>
		</EditorialUpdatesSectionContainer>
	)
}

EditorialUpdatesSection.propTypes = {
	lastModified: string.isRequired,
	lastModifiedText: string.isRequired,
}
